module.exports = __webpack_public_path__ + "static/media/ana-furniture-large.897bf80c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/ana-furniture-large.png
// module id = 803
// module chunks = 27